import React from 'react'
import { Subscribe } from './subscribe'
import { DocLink } from './page-content/docs/doc-link'
import { Link } from './Link'

const socialLinks: { href: string; label: string; icon: string }[] = [
  { href: 'https://www.facebook.com/profile.php?id=100071024083715', label: 'Facebook', icon: 'bxl-facebook' },
  { href: 'https://www.youtube.com/channel/UChYivizdvnEQgVuwOfKZr0Q', label: 'YouTube', icon: 'bxl-youtube' },
]

export const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="footer-info">
                <h3>PCM Leasing Inc.</h3>
                <p>
                  1958 S. Winnebago Road, Winnebago <br />
                  IL 61088, USA
                  <br />
                  <br />
                  <strong>Phone:</strong>{' '}
                  <a href="tel:8556455776" className="text-white">
                    855-645-5776
                  </a>
                  <br />
                  <strong>Email:</strong>
                  <a className="text-white" href="mailto:support@totalmilk.com">
                    support@totalmilk.com
                  </a>
                  <br />
                </p>
                <div className="social-links mt-3">
                  {socialLinks.map(({ href, label, icon }) => (
                    <a
                      key={href}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Total Milk on ${label}`}
                    >
                      <i className={`bx ${icon}`} aria-hidden="true" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <i className="bx bx-chevron-right" /> <Link to="/">Home</Link>
                </li>
                <li>
                  <i className="bx bx-chevron-right" />{' '}
                  <DocLink slug={'total-milk-terms-of-service'}>Terms of service</DocLink>
                </li>
                <li>
                  <i className="bx bx-chevron-right" />{' '}
                  <DocLink slug={'total-milk-privacy-policy'}>Privacy policy</DocLink>
                </li>
                <li>
                  <i className="bx bx-chevron-right" />{' '}
                  <Link reloadDocument to="/docs">
                    Docs
                  </Link>
                </li>

                <li>
                  <i className="bx bx-chevron-right" /> <Link to="/data-deletion-request">Request Data Deletion</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-md-6 footer-links">
              <h4>Our Apps</h4>
              <ul>
                <li>
                  <i className="bx bx-chevron-right" /> <Link to="/payroll">Total Milk Payroll</Link>
                </li>
                <li>
                  <i className="bx bx-chevron-right" /> <Link to="/hauler">Total Milk Hauler</Link>
                </li>
                <li>
                  <i className="bx bx-chevron-right" /> <Link to="/lab">Total Milk Lab</Link>
                </li>
                <li>
                  <i className="bx bx-chevron-right" /> <Link to="/principal">Total Milk Principal</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-6 footer-newsletter">
              <h4>Our Newsletter</h4>
              <p>Learn Total Milk from the basics to advanced topics at our FREE training webinars.</p>
              <Subscribe />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="copyright">
          © Copyright{' '}
          <strong>
            <span>PCM Leasing, Inc</span>
          </strong>
          . All Rights Reserved
        </div>
        <div className="credits">
          {/* All the links in the footer should remain intact. */}
          {/* You can delete the links only if you purchased the pro version. */}
          {/* Licensing information: https://bootstrapmade.com/license/ */}
          {/* Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/sailor-free-bootstrap-theme/ */}
          Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
        </div>
      </div>
    </footer>
  )
}
